import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Modal, Button, Icon } from 'antd';

import {
  groupInsert,
  groupList
} from '../../../modules/group';

import GroupDetails from '../form/GroupDetails';

class AddGroupModal extends Component {
	constructor(props){
		super(props);
		this.state = {
			loading: false,
		}
	}

	onClose() {
		this.setState({ 	
			step: 0,
		});
		this.props.toggleAddModal();
	}

	onAdded() {
		this.setState({ 	
			step: 0,
		});
		this.props.toggleAddModal();
		this.props.groupList();
	}

	render() {
    const { loading } = this.state;
    const { selected } = this.props;

		return (
			<Modal
				title={<span><Icon type="file-add" /> {selected ? `編輯班別/學生` : '新增班別/學生'}</span>}
				visible={this.props.show}
				onCancel={()=>this.onClose()}
				footer={[
					<Button key="back" onClick={()=>this.onClose()} disabled={loading}>取消</Button>
				]}
				maskClosable={false}
				closable={(loading) ? false : true}
			>
				<GroupDetails data={selected} callback={()=>this.onAdded()} show={this.props.show} />
			</Modal>
		);
	}
}

const mapStateToProps = state => ({
	router: state.router,
	userProfile: state.user.userProfile
});

const mapDispatchToProps = dispatch =>
bindActionCreators(
	{
		groupInsert,
		groupList,
	},
	dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(AddGroupModal);